export enum Colours {
  BASE = "#000000",
  PRIMARY = "#14213D",
  SECONDARY = "#FCA311",
  SHADE = "#E5E5E5",
  BACKGROUND = "#FFFFFF"
}